import { useEffect, useState } from 'react'

export let useDebouncedValue = <T>(value: T, delay = 300): T => {
  let [debounced, setDebounced] = useState(value)
  useEffect(() => {
    let id = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(id)
  }, [value, delay])
  return debounced
}
